export enum SEGMENTS {
  singlepage = 'SINGLE_PAGE',
  multipage = 'MULTI_PAGE',
}

export const segments = [
  {
    key: SEGMENTS.multipage,
    text: 'Multi page',
  },
  {
    key: SEGMENTS.singlepage,
    text: 'Single page',
  },
];

export const getSegmentIndexForPreviewToggle = (key: string): number =>
  `${key}` === 'MULTI_PAGE' ? 1 : 0;
